import { columnHelper } from './helper';

export const resourceGroup = columnHelper.accessor('resourceGroup', {
  header: 'Resource Group',
  cell: ({ getValue }) => getValue() || '-',
});
